import React from 'react';
import { Button } from 'react-bootstrap';


const Footer = ()=>{
    
    return(
        <footer>
          <div className='footer_inner'>
            <div>
            <img src={process.env.PUBLIC_URL + "/img/logo.png"} width="100%" alt='news' />
            </div>
            <div className='info'>
              <ul>
                <li>회사소개</li>
                <li>이용약관</li>
                <li>개인정보처리방침</li>
                <li>이용안내</li>
              </ul>
              <ul>
              <li>㈜에스제이그룹 ㅣ 대표 : 이주영 ㅣ 사업자등록번호 : 211-88-10329 [사업자정보확인]</li>
              <li>통신판매업 신고번호 : 제2011-서울강남-02294호 ㅣ 개인정보관리자 : 고명란</li>
              <li>주소 : (06261) 서울특별시 강남구 도곡로 156 SJ빌딩</li>
              <li>온라인고객센터 : 1899-0186 ㅣ A/S 접수처 : 080-258-3883 ㅣ Fax : 02-3442-3515</li>
              </ul>
              <p>
              COPYRIGHTⓒ 2016 KANGOL®. ALL RIGHT RESERVED.
              </p>
            </div>
            <div className='center'>
              <h6>CUSTOMER CENTER</h6>
              <h1>1899-0186</h1>
              <ul>
                <li>MON - THU   10:00 - 17:00</li>
                <li>FRI   10:00 - 16:00</li>
                <li>LUNCH   13:00 - 14:00</li>
                <li>SAT - SUN   1:1 문의 이용</li>
              </ul>
            </div>
            <div className='notice'>
              <div>
                <h6>NOTICE</h6>
                <Button variant="outline-dark">MORE ▷ </Button>
              </div>
              <ul>
                <li>3월 1일 공휴일 배송 안내</li>
                <li>설 연휴 배송 안내</li>
                <li>적립금 소명 안내 (2020.12.31 이전 적립금)</li>
              </ul>
            </div>
          </div>
      </footer>
    )
}

export default Footer;